<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="h-full w-full">
    <!-- 
        Only elements with [modal-drag-handle] are projected into cdkDragHandle,
        restricting dragging to those elements only
    -->
    <div cdkDragHandle class="drag-handle">
        <ng-content select="[modal-drag-handle]"></ng-content>
    </div>

    <ng-content></ng-content>
</div>
